import {h, Fragment} from "preact"
import { useAppStateSelector } from "@nosto/preact"
import Sidebar from "./Sidebar"
import { translatedText } from "./utils/translatedText";
import { useEffect, useState } from "preact/hooks"

/**
 * ContentWrapper takes a function to render non-empty results in the content area.
 * On loading the Loader is used and for empty results the NoResults component is used.
 */
 function ContentWrapper({ type, children }) {
    const { foundProducts, loading, query: globalQuery } = useAppStateSelector(
      (state) => ({
        foundProducts: state.response.products?.total > 0,
        loading: state.loading,
        query: state?.query,
      })
    );
  
    const initialValue =
      typeof globalQuery?.query === "string" ? globalQuery.query : "";
  
    const [inputValue, setInputValue] = useState(initialValue);
  
    useEffect(() => {
      if (typeof globalQuery?.query === "string") {
        setInputValue(globalQuery.query);
      }
    }, [globalQuery?.query]);
  
    // Fire a window-level CustomEvent so Alpine can catch `x-on:search-toggle.window`
    const openSearchDrawer = () => {
      window.dispatchEvent(new CustomEvent("search-toggle"));
      // If your Alpine code exposes this globally, call it:
      if (typeof window.setScrolledState === "function") {
        window.setScrolledState();
      }
    };
  
    const handleKey = (e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        openSearchDrawer();
      }
    };
  
    return (
      <main-search>
        <div id="search_page_input-wrapper" class="p-12 lg:p-24 relative">
          <p class="text-10-120 lg:text-11-120 text-black-55 mb-24 capitalize">
            {translatedText("searchResultsFor")}
          </p>
  
          <div class="">
            {/* Clickable display instead of input; opens Alpine drawer */}
            <span
              role="button"
              tabIndex={0}
              aria-label={translatedText("searchHere")}
              onClick={openSearchDrawer}
              onKeyDown={handleKey}
              class="placeholderSearch text-28-90--0.5-900 leading-none capitalize w-full pr-32 lg:text-32-100--0.5-900 md:pr-96 block cursor-text select-none"
            >
              {inputValue?.trim() || translatedText("searchHere")}
            </span>
          </div>
        </div>
  
        <div
          class="ns-serp ns-d-flex ns-flex-column ns-font-inherit ns-my-0 relative"
          data-nosto-element={type}
        >
          {foundProducts && <Sidebar />}
          <div
            class="px-12 pb-48 relative lg:px-24"
            style={{ position: loading ? "relative" : "initial" }}
          >
            {children({ loading, foundProducts })}
          </div>
        </div>
      </main-search>
    );
  }
  
  export function wrapContent(type, Component) {
    return () => <ContentWrapper type={type}>{Component}</ContentWrapper>;
  }